import React, { type FC, type PropsWithChildren } from 'react';

import ABTest from '../../ab-test/ab-test';

export interface NavDemoLinkProps {
  willTriggerFire?: boolean;
  className?: string;
}

const NavDemoLink: FC<PropsWithChildren<NavDemoLinkProps>> = ({ children, willTriggerFire, className }) => (
  <ABTest
    isAboveTheFold
    branchesToRender={['T_A', 'T_B']}
    className={className}
    testName="LucidSuiteNavWatchADemo2"
    willTriggerFire={willTriggerFire}
  >
    {children}
  </ABTest>
);

export default NavDemoLink;
